// Core Modules
import { DatePipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

// External Modules
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { debounceTime, distinctUntilChanged, isObservable, Observable, Subject, Subscription } from 'rxjs';

// Models
import { IPageTitleModel } from '@shared/models/page-title-config-model';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss',
  standalone: true,
  imports: [DatePipe, FormsModule, NgbDropdownModule, NgbTooltipModule, NgClass, NgxPermissionsModule, RouterLink],
})
export class PageTitleComponent implements OnInit, OnDestroy {
  // Bindings
  @Input() badgeMessage?: Observable<string>;
  @Input() pageTitleConfig?: IPageTitleModel;
  @Output() readonly callBack: EventEmitter<Record<string, string>> = new EventEmitter<Record<string, string>>();
  @Output() readonly ddlSelectedItem: EventEmitter<string> = new EventEmitter<string>();
  @Output() readonly searchCallBack: EventEmitter<string> = new EventEmitter<string>();

  // Private Members
  private readonly subscription: Subscription = new Subscription();

  // Public Members
  public readonly searchStringUpdate = new Subject<string>();
  public badgeMessageText?: string;
  public lookupWord?: string;

  constructor() {
    this.searchStringUpdate.pipe(debounceTime(300), distinctUntilChanged()).subscribe((value) => {
      this.searchCallBack.emit(value);
    });
  }

  public ngOnInit(): void {
    if (isObservable(this.badgeMessage)) {
      this.subscription.add(
        this.badgeMessage?.subscribe({
          next: (msg: string) => {
            this.badgeMessageText = msg;
          },
          error: (error: Error) => {
            console.log('Error occurred', error);
          },
          complete: () => {
            console.log('completed...');
          },
        })
      );
    }
  }

  public btnClickCallback(param: Record<string, string | undefined>): void {
    this.callBack.emit(param as Record<string, string>);
  }

  public search(): void {
    this.searchCallBack.emit(this.lookupWord);
  }

  public selectItem(item?: string): void {
    this.ddlSelectedItem.emit(item);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
